/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const TruckBedLong = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 120 73" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M.1 49.6v9.6h44.8v-.3c0-3.3.9-6.5 2.7-9.3H.1zM118.2 49.6H77.3c1.8 2.8 2.7 6 2.7 9.3v.3h38.2c.9 0 1.6-.7 1.6-1.6v-6.4c0-.9-.7-1.6-1.6-1.6zM62.4 41.3c4.6 0 9.1 1.8 12.4 5.1H115V21H6.7V.2H.1v46.2h50c3.3-3.2 7.7-5.1 12.3-5.1zm45.8-6.7c0-.8.7-1.4 1.4-1.4h1.3c.8 0 1.4.7 1.4 1.4v7.8c0 .8-.7 1.4-1.4 1.4h-1.3c-.8 0-1.4-.7-1.4-1.4v-7.8z" /><circle cx="62.5" cy="59" r="13.7" /></g>
      </g>
    </svg>
  </span>
);

TruckBedLong.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

TruckBedLong.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default TruckBedLong;
